export default __webpack_public_path__ + "marker-500-074fd93ccb62f6e7fa3aeddbef18f717.png";